/**
 *
 * Lead Status
 *
 *
 */

import React, { useState } from "react"
import PropTypes from "prop-types"
import { Formik, Form } from "formik"
import { useDispatch } from "react-redux"
import { Button, Modal, Row, Col, Alert, Label } from "reactstrap"
import { ImplementationFor } from "../../../../components/DynamicForm/utils"
import ButtonSpinner from "../../../../components/ButtonSpinner"
import { resolveColumns } from "helpers/tools"
// import columns from './schema'
import * as Yup from "yup"

function LeadStatus(props) {
  const [showModal, setModalOpen] = useState()
  const [formRecord, setFormRecord] = useState()
  const { colorCode, row, error, metaData, actions, btnStyle = {} } = props
  const { leadNo, _id, companyId, branchId, priorityStatusId } = row

  const dispatch = useDispatch()

  const columns = (record = {}, metaData) => {
    const branchOptions =
      record &&
      record.companyId &&
      metaData &&
      Object.keys(metaData).length > 0 &&
      metaData.branchOptions &&
      metaData.branchOptions.length > 0
        ? metaData.branchOptions.filter(
            (_) => _.companyId.toString() === record.companyId.toString()
          )
        : row &&
          row.companyId &&
          metaData &&
          Object.keys(metaData).length > 0 &&
          metaData.branchOptions &&
          metaData.branchOptions.length > 0
        ? metaData.branchOptions.filter(
            (_) => _.companyId.toString() === row.companyId.toString()
          )
        : []

    //   console.log(branchOptions, "branchOptions")
    //   console.log(record, "companyId")

    // const companyId =  localStorage.getItem("manageLeadCompanyId")
    // console.log(companyId, "manageLeadCompanyId")
    return [
      {
        id: "1",
        value: "companyId",
        label: "Company",
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "4",
          md: "4",
        },
        type: "select",
        options: "companyOptions",
      },
      {
        id: "2",
        value: "branchId",
        label: "Branch",
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "4",
          md: "4",
        },
        type: "select",
        options: branchOptions,
      },
      {
        id: "3",
        value: "assignedTo",
        label: "Employee",
        placeholder: "Search Employee Code",
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "4",
          md: "4",
        },
        customLabel: ({ name, required, label }) => {
          return (
            <Label htmlFor={name}>
              {label}{" "}
              {required ? <span style={{ color: "red" }}>*</span> : null}{" "}
              <span style={{ color: "red" }}>(Auto Fill)</span>
            </Label>
          )
        },
        type: "autocomplete",
        fuseOptions: { keys: ["empCode", "name"] },
        options: "employeeListOptions",
      },
      {
        id: "4",
        value: "priorityStatusId",
        label: "Priority Status",
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "4",
          md: "4",
        },
        type: "select",
        options: "priorityStatusOptions",
      },
    ]
  }

  const fields = resolveColumns(columns, formRecord, metaData)

  // useEffect(()=> {
  //     if(showModal === true) {

  //         const manageLeadCompanyId = localStorage.setItem("manageLeadCompanyId", row.companyId)
  //         console.log(manageLeadCompanyId, "companyId")
  //     } else {
  //         const manageLeadCompanyId = localStorage.setItem("manageLeadCompanyId", "")
  //         console.log(manageLeadCompanyId, "modal companyId")
  //     }

  // }, [showModal])
  // console.log(row, "row leadStatus")

  return (
    <div>
      <Button
        style={
          colorCode
            ? { backgroundColor: colorCode, border: "none", padding: "6px" }
            : btnStyle
        }
        color="primary"
        onClick={() => setModalOpen(!showModal)}
      >
        {`${
          (row && row.processStatus && row.processStatus.processStatusName) ||
          ""
        }`}
      </Button>
      <Modal
        size="xl"
        isOpen={showModal}
        toggle={() => setModalOpen(!showModal)}
      >
        <Formik
          enableReinitialize={true}
          initialValues={{
            _id,
            leadStatus: "PS2",
            companyId,
            branchId,
            priorityStatusId,
          }}
          validationSchema={Yup.object().shape(
            (fields || [])
              .filter((_) => _.required)
              .reduce(
                (a, el) =>
                  Object.assign({}, a, {
                    [el.value]: Yup.string().required(
                      `${el.label} is required`
                    ),
                  }),
                {}
              )
          )}
          onSubmit={(values, { setSubmitting }) => {
            dispatch(
              actions.leadStatus(values, setSubmitting, () =>
                setModalOpen(!showModal)
              )
            )
          }}
        >
          {({
            values,
            errors,
            handleSubmit,
            setFieldValue,
            isSubmitting,
            touched,
            setFieldTouched,
          }) => (
            <Form onSubmit={handleSubmit} className="form-horizontal">
              <div
                className="modal-header"
                style={{ backgroundColor: "#E40D8C" }}
              >
                <h5
                  className="modal-title mt-0"
                  style={{ color: "white", textTransform: "uppercase" }}
                >
                  Lead No: {leadNo}
                </h5>
              </div>
              <div className="modal-body" style={{ borderTop: "none" }}>
                <Row>
                  {(fields || []).map((field, index) => {
                    const InputComponent = ImplementationFor[field.type]
                    return (
                      <Col
                        key={index}
                        className="mb-3"
                        item
                        xs={12}
                        {...(field.colProps || {})}
                      >
                        <InputComponent
                          {...field}
                          name={field.value}
                          value={values && values[field.value]}
                          isInvalid={
                            errors[field.value] && touched[field.value]
                          }
                          metaData={metaData}
                          setFieldValue={setFieldValue}
                          touched={touched[field.value]}
                          onChange={(e) => {
                            setFieldTouched(field.value)
                            setFieldValue(
                              field.value,
                              field.type === "select" ||
                                field.type === "multiSelect" ||
                                field.type === "autocomplete"
                                ? e.value
                                : field.type === "checkbox" &&
                                  field.name != "permission"
                                ? e.target.checked
                                : e.target.value
                            )
                            setFormRecord(
                              Object.assign({}, values, {
                                [field.value]:
                                  field.type === "select" ||
                                  field.type === "multiSelect" ||
                                  field.type === "autocomplete"
                                    ? e.value
                                    : field.type === "checkbox" &&
                                      field.name != "permission"
                                    ? e.target.checked
                                    : e.target.value,
                              })
                            )
                          }}
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        >
                          {errors[field.value] && touched[field.value]
                            ? errors[field.value]
                            : null}
                        </div>
                      </Col>
                    )
                  })}
                  {error ? (
                    <Col className="mb-3" item xs={12}>
                      <div className="mb-3">
                        <Alert color="danger" role="alert">
                          {error && typeof error === "object"
                            ? JSON.stringify(error)
                            : error}
                        </Alert>
                      </div>
                    </Col>
                  ) : null}
                </Row>
              </div>
              <div className="modal-footer">
                <button
                  onClick={() => setModalOpen(!showModal)}
                  type="button"
                  className="btn btn-danger btn-label simple-form-cancel-btn"
                >
                  <i className="bx bx-block label-icon "></i>Cancel
                </button>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="btn btn-success btn-label simple-form-submit-btn"
                >
                  <i className="bx bx-check-double label-icon"></i>
                  {isSubmitting ? <ButtonSpinner /> : "Submit"}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
    </div>
  )
}

LeadStatus.propTypes = {
  t: PropTypes.any,
  colorCode: PropTypes.any,
  row: PropTypes.any,
  fields: PropTypes.any,
  title: PropTypes.any,
  error: PropTypes.any,
  formTitle: PropTypes.any,
  metaData: PropTypes.any,
  actions: PropTypes.any,
  btnStyle: PropTypes.any,
}

export default LeadStatus
